import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { enableMocking } from './libs/msw/browser';
import initializeSentry from './libs/sentry/sentry';
import App, { router } from './App';
import { restoredIntent } from './features/checkout/auth';
import { saveIntent } from './features/checkout/intent';
import { Auth0Provider } from '@auth0/auth0-react';
import { initializeMixpanel } from './libs/mixpanel/mixpanel';

if (import.meta.env.ENVIRONMENT === 'PRODUKCE' || import.meta.env.ENVIRONMENT === 'PREPRODUKCE') {
  initializeMixpanel();
  initializeSentry();
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Auth0Provider
        domain={import.meta.env.VITE_AUT0_DOMAIN}
        clientId={import.meta.env.VITE_AUT0_CLIENT_ID}
        onRedirectCallback={appState => {
          const intent = restoredIntent(appState);
          if (intent) {
            saveIntent(intent);
            void router.navigate('/checkout', { replace: true, state: intent });
          } else {
            const target = appState?.returnTo;
            const safe =
              typeof target === 'string' &&
              target.startsWith('/') &&
              !target.startsWith('//') &&
              !target.includes('\\');
            void router.navigate(safe ? target : window.location.pathname, { replace: true });
          }
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        authorizationParams={{
          ui_locales: 'cs',
          redirect_uri: `${window.location.origin}/hairdresser`,
          audience: import.meta.env.VITE_AUT0_AUDIENCE,
          scope: 'openid profile email offline_access read:current_user',
        }}
      >
        <App />
      </Auth0Provider>
    </StrictMode>,
  );
});
